import { CorporationResponse } from '@kcftech/prometheus-client';
import { skipToken, useQuery } from '@tanstack/react-query';
import { dayMs, hourMs } from 'components/date_time/time';
import { sdClient } from 'contexts/SDKClientContext';

export function useCorporation(id: string | undefined, immediate?: boolean) {
    return useQuery<CorporationResponse | undefined, Partial<Error>>({
        queryKey: [`corporation-${id}`],
        queryFn: id ? async () => sdClient.getCorporation({ id }) : skipToken,
        gcTime: 7 * dayMs,
        staleTime: 6 * hourMs,
        refetchOnMount: immediate,
    });
}
